<template>
    <v-dialog v-model="dialog" scrollable>
        <template v-slot:activator="{ on }">
            <v-btn text v-on="on">
                GetInvoices
            </v-btn>
        </template>
        <v-card>
            <v-card-title v-if="activecontact">
                Invoices - {{activecontact.info.name}}
                <v-spacer/>
                <v-btn icon small @click="Close()"><v-icon>{{icons.close}}</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
                <InvoiceList :invoices="invoices" :loadingdata="loading" />
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="Close()">close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import InvoiceList from "@/views/invoicing/InvoiceList";
  export default {
    props:['uuid'],
    name: "InvoicesByCustomerUuid",
    components: {InvoiceList},
    data() {
      return {
        dialog: false,
        loading:false,
        data:[],
        invoices:[]
      }
    },
    computed: {
      ...mapState(['icons','activecontact'])
    },
    watch:{
      dialog(n){
        if(n) this.getInvoices()
        else this.invoices=[]
      }
    },
    methods: {
      ...mapActions(['get', 'post']),
      Close() {
        this.dialog = false
      },
      async getInvoices(){
        this.loading=true
        let rsp = await this.post({path:'api/invoicing/getbycustomeruuid',body:{uuid:this.uuid}})
        this.loading=false
        console.log(rsp)
        this.invoices=rsp
      }
    }
  }
</script>

<style scoped>

</style>